import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { Slider as SliderWidget, SLIDER_SIZE } from "widgets/inputs";

import { Base } from "../base";

import styles from "./slider.css";

export function Slider(props) {
  const { column, value, pos } = props;
  const baseRef = useRef(null);
  const inputRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(
    function onValueChange() {
      setCurrentValue(value || "");
    },
    [value, pos]
  );

  return (
    <Base {...props} ref={baseRef} onEditing={(e) => {}} type="slider">
      <div className={styles.slider}>
        <SliderWidget
          ref={inputRef}
          value={currentValue}
          min={parseFloat(column.min)}
          max={parseFloat(column.max)}
          intervalSize={parseFloat(column.intervalSize || 1)}
          readOnly={column.readOnly}
          onChange={(value) => {
            baseRef.current.startEditing(value);
            baseRef.current.dataChanged(value);
            baseRef.current.dataCompleted();
          }}
          size={SLIDER_SIZE.SMALL}
          showToolTip={true}
          trackAutoWidth={true}
          getTooltipContainer={(trigger) => {
            return trigger?.parentElement?.parentElement?.parentElement
              ?.parentElement?.parentElement?.parentElement?.parentElement
              ?.parentElement;
          }}
        />
      </div>
    </Base>
  );
}

Slider.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  pos: PropTypes.any
};
